var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classes,attrs:{"data-testid":"home-illustration"}},[(_vm.isThemeWarrenManaged)?_c('div',{staticClass:"home-illustration__dynamic",attrs:{"data-testid":"home-illustration-dynamic"}},[_c('div',{staticClass:"home-illustration__dynamic--prefetch"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }